import { Tooltip } from '@mui/material';
import ToggleButton from '@mui/material/ToggleButton';
import GetApp from '@mui/icons-material/GetApp';
import * as FileSaver from 'file-saver';
import ExcelJS from 'exceljs';
import AdminTrackExportConfigData from '../../config/AdminTrackExportConfig.json';

const ExportAdminTrackCSV = ({ csvData, fileName }) => {
    const fileExtension = '.xlsx';

    const exportToCSV = async (csvData, fileName) => {
        const columns = AdminTrackExportConfigData.columns;
        const dcrData = [];
        const mergeData = [];
        const subscriptionData = [];
        const employerData = [];
        csvData.forEach((row) => {
            const requestType = row['RequestType'];
            
            if (requestType === 'DCR') {
                const dcrRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        dcrRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        dcrRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        dcrRow[column.label] = row[columnId];
                    }
                });
                dcrData.push(dcrRow);
            } else if (requestType === 'Direct-Employer') {
                const employerRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        employerRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        employerRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        employerRow[column.label] = row[columnId];
                    }
                });
                employerData.push(employerRow);
            } else if (requestType === 'Merge') {
                const mergeRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        mergeRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        mergeRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        mergeRow[column.label] = row[columnId];
                    }
                });
                mergeData.push(mergeRow);
            } else if (requestType === 'Subscription') {
                const subscriptionRow = {};
                columns.forEach((column) => {
                    const columnId = column.id;
                    if(column.id === 'CreatedBy'){
                        subscriptionRow[column.label] = row['RequestorName'] && row['CreatedBy'] ? `${row['RequestorName'].includes(" - Network") ? row['RequestorName'].split(" - Network")[0].trim() : row['RequestorName']} (${row['CreatedBy']})` : row['CreatedBy'] || row['RequestorName'] ||'N/A'
                    }else if(column.id === 'RequestorEmail'){
                        subscriptionRow[column.label] = row[columnId] || 'N/A';
                    }else{
                        subscriptionRow[column.label] = row[columnId];
                    }
                });
                subscriptionData.push(subscriptionRow);
            }
        });

        const workbook = new ExcelJS.Workbook();

        const createWorksheet = (data, sheetName) => {
            const worksheet = workbook.addWorksheet(sheetName);
            worksheet.columns = columns.map(column => {
                    return ({ header: column.label, key: column.label })
            }
            ).filter(Boolean);
            data.forEach(row => {
                worksheet.addRow(row);
            });

            // Set column widths
            worksheet.columns.forEach(column => {
                const maxLen = Math.max(...data.map(row => (row[column.key] ? row[column.key].toString().length : 0)), column.header.length);
                column.width = Math.max(20, maxLen + 2); // Add some padding
            });

            worksheet.autoFilter = worksheet.getColumn(1).letter + '1:' + worksheet.getColumn(worksheet.columns.length).letter + (data.length + 1);
        };

        createWorksheet(dcrData, 'DCR');
        createWorksheet(mergeData, 'Merge');
        createWorksheet(subscriptionData, 'Subscription');
        createWorksheet(employerData, 'Direct-Employer');

        const buffer = await workbook.xlsx.writeBuffer();
        const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
        <ToggleButton
            value="list"
            size="small"
            className="border-0 float-end"
            aria-label="list"
            onClick={(e) => exportToCSV(csvData, fileName)}
        >
            <Tooltip disableFocusListener title="Export" id="tooltip" >
                <GetApp />
            </Tooltip>
        </ToggleButton>
    );
};

export default ExportAdminTrackCSV;